module.exports = __webpack_public_path__ + "img/about-pic-1.53c9636a.jpg";